import { compose, setDisplayName } from 'react-recompose';
import { formValueSelector } from 'redux-form/immutable.js';

import { getOrganizatioTypesByItem } from '~/state/ducks/app/selectors.js';
import withReduxConnect from '~/views/enhancers/withReduxConnect.js';

import OrganizationForm from '../components/OrganizationForm.jsx';


export default compose(
    setDisplayName('OrganizationsFormContainer'),
    withReduxConnect({
        mapStateToProps: (state, { form }) => ({
            isPortal: formValueSelector(form)(state, 'portal'),
            organizatioTypesByItem: getOrganizatioTypesByItem(state),
        }),
    }),
)(OrganizationForm);
